import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    isLogin: false,
    userId: undefined,
    userType: undefined,
    oldMode: false,
  },
  mutations: {
    changeLoginStatus (state, payload) {
      state.isLogin = payload
    },
    changeUserId (state, payload) {
      state.userId = payload
    },
    changeUserType (state, payload) {
      state.userType = payload
    },
    changeOldMode (state, payload) {
      state.oldMode = payload
    }
  }
})

export default store
